// extracted by mini-css-extract-plugin
export var headerXL = "BlogFeatuerdPost-module--headerXL--3z797";
export var headerL = "BlogFeatuerdPost-module--headerL--2CZAH";
export var headerM = "BlogFeatuerdPost-module--headerM--3UPs4";
export var headerS = "BlogFeatuerdPost-module--headerS--CJheZ";
export var headerXS = "BlogFeatuerdPost-module--headerXS--1bccr";
export var blogHeaderXL = "BlogFeatuerdPost-module--blogHeaderXL--2JQyx";
export var blogHeaderL = "BlogFeatuerdPost-module--blogHeaderL--2-Y7u";
export var blogHeaderM = "BlogFeatuerdPost-module--blogHeaderM--2fzXk";
export var blogHeaderS = "BlogFeatuerdPost-module--blogHeaderS--1QS2z";
export var blogHeaderXS = "BlogFeatuerdPost-module--blogHeaderXS--24-LI";
export var headerPreamble = "BlogFeatuerdPost-module--headerPreamble--3h7V6";
export var preHeader = "BlogFeatuerdPost-module--preHeader--29xDA";
export var textNormal = "BlogFeatuerdPost-module--textNormal--3uMxO";
export var textSmall = "BlogFeatuerdPost-module--textSmall--_J4VI";
export var textSmallAlternate = "BlogFeatuerdPost-module--textSmallAlternate--2JuZW";
export var legend = "BlogFeatuerdPost-module--legend--1NIDq";
export var caption = "BlogFeatuerdPost-module--caption--pZwS6";
export var gradientBackground = "BlogFeatuerdPost-module--gradientBackground--3Fykm";
export var ellipsis = "BlogFeatuerdPost-module--ellipsis--1kTjh";
export var globalContainer = "BlogFeatuerdPost-module--globalContainer--g8kQM";
export var maxWidth = "BlogFeatuerdPost-module--maxWidth--x5URl";
export var clipBottom = "BlogFeatuerdPost-module--clipBottom--_v1aj";
export var clipTopBottom = "BlogFeatuerdPost-module--clipTopBottom--1_18j";
export var container = "BlogFeatuerdPost-module--container--2JY3R";
export var description = "BlogFeatuerdPost-module--description--2DPl6";
export var metadata = "BlogFeatuerdPost-module--metadata--_Nz0J";
export var excerpt = "BlogFeatuerdPost-module--excerpt--BWxBG";
export var image = "BlogFeatuerdPost-module--image--3gI15";
export var ch2 = "BlogFeatuerdPost-module--ch2--1795C";
export var ch2Container = "BlogFeatuerdPost-module--ch2-container--3taZZ";